import React, {useState, useEffect, useRef, useMemo} from 'react'
import Select from 'react-select';
import {Label, Spinner} from 'reactstrap';
import {REQUIRED} from "../i18n/i18n";

const spinnerStyle = {
    marginTop:'25px'
}

const SelectGeneric = React.memo(({
    title = null,
    isDisabled = false,
    initialValue,
    setExternalValue,
    provider,
    resetValue = false,
    customFilter = {},
    hasError = false,
    itemsToExclude = [],
    menuPosition = 'absolute',
    setIsMenuOpen = (v) => {},
    showSpinner = true,
    errorMessage = REQUIRED,
    placeholder = 'Seleccione una opción...'
}) => {
    const [loading, setLoading] = useState(true)
    const [items, setItems] = useState([])
    const [value, setValue] = useState(null)

    const isMounted = useRef(true)

    const memoizedCustomFilter = useMemo(() => customFilter, [JSON.stringify(customFilter)]);

    //Actualizar la referencia
    useEffect(() =>{
        return ()=>{
            isMounted.current = false
        }
    },[])

    //Cargar los ITEMS
    useEffect(() => {

        setLoading(true)

        provider.getOptions(customFilter).then( result => {
            if(isMounted.current){
                if(result)
                    setItems(result)

                setLoading(false)
            }
        })
    }, [memoizedCustomFilter])

    //Cargar el item default
    useEffect(() => {
        if(!isMounted.current)
            return

        if(!initialValue)
            setValue(null)

        if(initialValue != null && items.length > 0 && isMounted.current){
            setLoading(true)

            const item = items.find( i => i.id === initialValue)
            setValue(item)

            setLoading(false)
        }
    }, [ items, initialValue ])

    // resetear el valor del select
    useEffect(() => {
        if(isMounted.current)
            setValue(null)
    }, [ resetValue ])


    // excluir los items que su id este dentro de la lista a excluir
    useEffect(()=>{
        if(loading || itemsToExclude.length <= 0)
            return

        if(isMounted.current)
            setItems( items.filter(i =>  !itemsToExclude.includes(i?.id) ))
    }, [itemsToExclude, loading])


    return loading && showSpinner ? <Spinner animation="border" style={ spinnerStyle } /> : <>
        {
            title && <>
                <Label className={(hasError ? 'label-is-invalid' : '')}>{title}</Label>
                <br/>
            </>
        }
        <Select
            value={ value }
            options={ items }
            isDisabled={ isDisabled }
            isClearable={ true }
            onChange={ val => {
                setValue(val)
                setExternalValue(val?.id)
            } }
            className={"select-generic " + ((hasError === true) && "is-invalid")}
            placeholder={placeholder}
            menuPosition={ menuPosition }
            menuPortalTarget={document.body}
            onMenuOpen={() => setIsMenuOpen(true)}
            onMenuClose={() => setIsMenuOpen(false)}
            isLoading={ loading }
            styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }) // Asegura que el menú esté por encima
            }}
        />
        { hasError && <div className="invalid-feedback" style={{'display':'block'}}>  {errorMessage} </div> }
    </>
})

export default SelectGeneric
